/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DoctorAccess from './doctor-access';
import DoctorAccessDetail from './doctor-access-detail';
import DoctorAccessUpdate from './doctor-access-update';
import DoctorAccessDeleteDialog from './doctor-access-delete-dialog';

const DoctorAccessRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DoctorAccess />} />
    <Route path="new" element={<DoctorAccessUpdate />} />
    <Route path=":id">
      <Route index element={<DoctorAccessDetail />} />
      <Route path="edit" element={<DoctorAccessUpdate />} />
      <Route path="delete" element={<DoctorAccessDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DoctorAccessRoutes;
